import { ChangeDetectorRef, Component, Input, OnInit } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { first } from "rxjs/operators";
import { TaskDocument } from "../../core/model/task-document";
import { TaskDocumentService } from "../../core/service/task-document.service";

@Component({
  selector: "app-edit-task-document",
  templateUrl: "./edit-task-document.component.html",
  styleUrls: ["./edit-task-document.component.scss"],
})
export class EditTaskDocumentComponent implements OnInit {
  @Input()
  set taskDocument(value: TaskDocument) {
    if (value) {
      this._taskDocument = { ...value };
      this.cdr.detectChanges();
    }
  }
  get taskDocument(): TaskDocument {
    return this._taskDocument;
  }

  private _taskDocument: TaskDocument;

  form2: FormGroup;
  pressButton: Boolean = false;
  loading = false;

  constructor(
    private _taskDocumentService: TaskDocumentService,
    private fb: FormBuilder,
    public activeModal: NgbActiveModal,
    private cdr: ChangeDetectorRef
  ) {
    this.createForm();
  }

  createForm() {
    this.form2 = this.fb.group({
      active: [null, Validators.compose([Validators.required])],
      obligatoire: [null, Validators.compose([Validators.required])],
      code: [null, Validators.compose([Validators.required])],
      label: [null, Validators.compose([Validators.required])],
      description: [null, Validators.compose([Validators.required])],
    });
  }

  ngOnInit() {}

  save(): void {
    this.pressButton = true;
    this._taskDocumentService
      .update(this.taskDocument)
      .pipe(first())
      .subscribe(
        () => {
          this.pressButton = false;
          this.activeModal.close(this.taskDocument);
        },
        (error) => {
          console.log(error);
          this.pressButton = false;
        }
      );
  }
}
